import { render, staticRenderFns } from "./ShapeShiftDemo.vue?vue&type=template&id=31e85524&scoped=true"
import script from "./ShapeShiftDemo.vue?vue&type=script&lang=js"
export * from "./ShapeShiftDemo.vue?vue&type=script&lang=js"
import style0 from "./ShapeShiftDemo.vue?vue&type=style&index=0&id=31e85524&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e85524",
  null
  
)

export default component.exports